import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Button, Dropdown, Menu } from 'antd'

import styled from 'styled-components'
import { LeftOutlined, RightOutlined, PlusOutlined } from '@ant-design/icons'
import more from '../../../icons/More.svg'
import { getCookie } from 'helper/cookie'
import 'styleLess/signature/kpi.scss'
import { getKpiSearch } from 'api/Project/kpifinance'
import emptyKPI from 'icons/createproject/emptyKPI.svg'
import { useHistory } from 'react-router-dom'
import lang from 'lang/en'
import FormatMoney from 'common/FormatNumber/money'
import FormatMinMax from 'common/FormatNumber/minmax'
import ModalAdd from 'common/KPIFinance/modalAddKPI'
import ModalDelete from 'common/KPIFinance/modalDelete'
import { Helmet } from 'react-helmet'
import NoPermission from 'common/KPIFinance/noPermissionKPI'
import FormatNumber from 'common/FormatNumber/money'
const ConatainerKPI = styled.div``
const SubContainer = styled.div``
const Header = styled.div``
const EmptyState = styled.div``
const Footer = styled.div``
const ContainerCard = styled.div``
const CardItem = styled.div``
const LeftCard = styled.div``
const RightCard = styled.div``

const initalState = {
  data: [],
  isLoading: true,
}
let idKPI = ''
const Kpifinance = (props) => {
  const {
    idEditPRJ,
    role,
    swithCaseFunction,
    canKPIFinance,
    setVisibleSaveDraft,
    form,
    checkBtn,
  } = props

  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const [dataKPIFinance, setDataKPIFinance] = useState(initalState.data)
  const history = useHistory()

  const language = getCookie('lang')
  const word = lang[language]

  //Modal

  const [visibleDelete, setVisibleDelete] = useState(false)
  const [visableModal, setVisableModal] = useState(false)
  const [typeBtn, setTypeBtn] = useState(false)
  const [dataEdit, setDataEdit] = useState()
  const getResultKpi = async () => {
    const data = {
      project_id: idEditPRJ,
      sprintflow_id: '0',
    }
    getKpiSearch({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataKPIFinance([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataKPIFinance(data.projects)
        } else {
          setDataKPIFinance([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataKPIFinance([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getResultKpi()
    }
  }, [token])
  const onDelete = (item) => {
    setVisibleDelete(true)
    idKPI = item.id
  }

  const menu = (item) => {
    return (
      <Menu>
        <Menu.Item key="0" onClick={() => onClickShowModal('edit', item)}>
          Edit
        </Menu.Item>
        <Menu.Item key="1" onClick={() => onDelete(item)}>
          Delete
        </Menu.Item>
      </Menu>
    )
  }

  //เพื่อแสดง modal saveDraft
  const onFinishSave = () => {
    if (checkBtn == 'save') {
      setVisibleSaveDraft(true)
    }
  }

  const btnStatus = () => {
    return <Form form={form} onFinish={onFinishSave}></Form>
  }

  const modalDelete = () => {
    return (
      <ModalDelete
        visibleDelete={visibleDelete}
        setVisibleDelete={setVisibleDelete}
        idEditPRJ={idEditPRJ}
        getResultKpi={getResultKpi}
        idKPI={idKPI}
      />
    )
  }

  const onClickNext = () => {
    swithCaseFunction('supportneed')
    history.push(`/project/${idEditPRJ}/supportneed`)
  }
  const onClickPrevious = () => {
    swithCaseFunction('role')
    history.push(`/project/${idEditPRJ}/role`)
  }
  const footer = () => {
    return (
      <Footer className="footer-btnPre-btnSave">
        <Button
          id="previouskpi"
          type="primary"
          className="BTN_Previous"
          onClick={() => onClickPrevious()}
          style={{ marginRight: 8 }}
        >
          <LeftOutlined className="Icon-color" />
          Previous
        </Button>
        <Button
          id="nextkpi"
          type="primary"
          className="BTN_Next "
          onClick={() => onClickNext()}
        >
          Next
          <RightOutlined className="Icon-color" />
        </Button>
      </Footer>
    )
  }

  const showModal = () => {
    return (
      <ModalAdd
        visableModal={visableModal}
        setVisableModal={setVisableModal}
        idEditPRJ={idEditPRJ}
        typeBtn={typeBtn}
        getResultKpi={getResultKpi}
        dataEdit={dataEdit}
        stateKPI="project"
        titlePage="Project"
      />
    )
  }

  const showGoalMinMax = (item) => {
    if (item.input_type_id === 23) {
      return (
        <div>
          <span className="small">Project Goal/unit</span>
          <p>
            <FormatMoney num={item.goal} /> {item.unit_type_name}
          </p>
        </div>
      )
    } else {
      return (
        <div>
          <span className="small">Project Min/Max / Unit</span>
          <p>
            <FormatMinMax num={item.min} /> - <FormatMinMax num={item.max} />{' '}
            {item.unit_type_name}
          </p>
        </div>
      )
    }
  }

  const onClickShowModal = (type, item) => {
    setDataEdit(item)
    setVisableModal(true)
    setTypeBtn(type)
  }

  const checkShowRemaining = (inputtype, item) => {
    if (inputtype == 22) {
    } else {
      return (
        <div>
          <span className="small">{word['addtask_kpi_title_remaining']}</span>
          <p>
            <FormatNumber num={item.goal - item.usegoal} /> {item.unit_type_name}
          </p>
        </div>
      )
    }
  }

  if (canKPIFinance == false) {
    return (
      <div>
        <Helmet>
          <title>Create Project | KPI/Finance</title>
        </Helmet>
        {btnStatus()}
        <NoPermission />
        <div>{footer()}</div>
      </div>
    )
  } else if (dataKPIFinance.length > 0) {
    return (
      <ConatainerKPI className="containerKPI">
        <Helmet>
          <title>Create Project | KPI/Finance</title>
        </Helmet>
        {btnStatus()}
        <Header className="header">
          <h2>Project KPI</h2>
          <Button
            id="btn_addKPI"
            className="BTN_Next"
            onClick={() => onClickShowModal('add')}
            hidden={role}
            icon={<PlusOutlined className="Icon-color" />}
          >
            Add KPI
          </Button>
        </Header>
        <SubContainer className="sub-container">
          <ContainerCard className="containerCard">
            {dataKPIFinance &&
              dataKPIFinance.map((item) => {
                return (
                  <CardItem className="card">
                    <LeftCard className="left-card">
                      <span className="small">KPI/Finance</span>
                      <div style={{ display: 'grid' }}>
                        <p className="cutter-text-line-1 ">{item.name}</p>
                      </div>

                      <div>
                        <span className="small">KPI Type</span>
                        <div style={{ display: 'grid' }}>
                          <p className="cutter-text-line-1 ">{item.kpi_type_name_en}</p>
                        </div>
                      </div>
                      <Row className="rowly-goal-minmax">
                        <Col>{showGoalMinMax(item)}</Col>
                        <Col>{checkShowRemaining(item.input_type_id, item)}</Col>
                      </Row>
                    </LeftCard>
                    <RightCard className="right-card">
                      <div className={role ? 'active-showmore' : ''}>
                        <Dropdown
                          overlay={(e) => menu(item)}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <a>
                            <img src={more} />
                          </a>
                        </Dropdown>
                      </div>
                    </RightCard>
                  </CardItem>
                )
              })}
          </ContainerCard>
        </SubContainer>
        {footer()}
        {showModal()}
        {modalDelete()}
      </ConatainerKPI>
    )
  } else {
    return (
      <ConatainerKPI className="containerKPI">
        <Helmet>
          <title>Create Project | KPI/Finance</title>
        </Helmet>
        {btnStatus()}
        <Header className="header">
          <h2>Project KPI</h2>
        </Header>
        <SubContainer className="sub-container">
          <EmptyState className="empty-kpi">
            <img src={emptyKPI} />
            <h2>Please add KPI/Finance in your project</h2>
            <Button
              id="btn_addNewKPI"
              className="BTN_Next"
              onClick={() => onClickShowModal('add')}
              hidden={role}
              icon={<PlusOutlined className="Icon-color" />}
            >
              Add New KPI/Finance
            </Button>
          </EmptyState>
        </SubContainer>
        {footer()}
        {showModal()}
      </ConatainerKPI>
    )
  }
}
export default Kpifinance
